module.exports = __webpack_public_path__ + "img/weixin.7abebdb0.jpg";